import { default as React } from "react";
import { XlWidget } from "./xlwidget";
import { TextField } from "../components/textfield";
export class TextXlWidget extends XlWidget {
    constructor(props) {
        super(props);
    }
    renderInner() {
        const type = this.props.type ? this.props.type : "text";
        return (React.createElement(TextField, { lang: this.props.lang, customValidation: this.props.customValidation, ref: (el) => (this.inputWrapper = el), disabled: this.props.saveInProgress || !!this.props.disabled, onKeyDown: this.handleKeyPress, onFocus: (e) => this.edit(), required: this.props.required, type: type, onValueChange: this.editValueUpdate, value: this.currentValue(), size: this.props.size }));
    }
}
export default TextXlWidget;
//# sourceMappingURL=textxlwidget.js.map